import React from 'react'
import { Icon } from 'components'

const Bottom = () => {
  return (
    <div className="bg-gray-800 bg-opacity-30 focus-within:relative">
      <div
        className="p-0 w-full bg-gradient-to-r from-gray-900 via-gray-700 to-gray-900"
        style={{ height: '1px' }}
      ></div>

      <div className="container flex justify-between leading-loose w-full items-center">
        <div className="py-8 text-gray-400 flex space-x-4 items-center text-sm">
          <span>© LeadBoxer BV.</span>
          <ul className="flex items-center space-x-4 m-0">
            <li>Privacy policy</li>
            <li>Terms of Service</li>
            <li>Website Data Collection</li>
          </ul>
        </div>

        <div className="flex items-center leading-none space-x-4">
          {['RiFacebookFill', 'RiLinkedinFill', 'RiTwitterFill'].map(
            (iconName) => (
              <Icon
                key={iconName}
                name={iconName}
                className="text-gray-300 fill-current"
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default Bottom
